module.exports = __webpack_public_path__ + "bg5.79481041707ec2525e2f.jpg";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/images/bg5.jpg
// module id = ../../../../../src/assets/images/bg5.jpg
// module chunks = main